const CHAT_BOT_REQUIRED_RESPONSE_COUNT = 6;

const matchChatbotResponseCounter = (loopedCounter: number): boolean => {
    return loopedCounter === 0 || loopedCounter >= CHAT_BOT_REQUIRED_RESPONSE_COUNT;
};

export default matchChatbotResponseCounter;
